import React from "react";
import styled from "styled-components";

import Heading from "core/Heading";
import PendingGroupGrid from "./PendingGroupGrid";

import { PendingGroupContainer } from "./styles";

let PendingGroup = ({ className, itemData }) => {
    return (
        <PendingGroupContainer className={className}>
            <Heading size="md" type="h2">
                Cute Pets Sept 30, 2021
            </Heading>
            <PendingGroupGrid itemData={itemData} />
        </PendingGroupContainer>
    );
};

PendingGroup = styled(PendingGroup)``;
export default PendingGroup;
